<div class="fullcontainer">
  @if (this.isError) {
    <div class="alert alert-danger">Please complete all required fields</div>
  }
  @if (this.isServerError) {
    <div class="alert alert-danger">Something went wrong. Please try again later.</div>
  }
  @if (this.isSuccess) {
    <div class="alert alert-success">Fuel record was updated successfully</div>
  }
  <div class='sheet'>
    <h1 class='header'>Edit Fuel Record</h1>
    <app-audit-line [data]='this.fuel'></app-audit-line>
    <form (ngSubmit)='this.onSubmit()' method='post'>
      <app-fuel-form [fuel]='this.fuel'></app-fuel-form>
      <button type="submit" class="btn btn-success">Save</button>&nbsp;
      <button type="button" class="btn btn-danger" routerLink='/vehicles'>Cancel</button>
    </form>
  </div>
</div>
